import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=048fbe12&scoped=true"
import script from "./QR.vue?vue&type=script&lang=ts"
export * from "./QR.vue?vue&type=script&lang=ts"
import style0 from "./QR.vue?vue&type=style&index=0&id=048fbe12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048fbe12",
  null
  
)

export default component.exports